import React from 'react';
import { IParsedDataCard } from '@/types';
import { Section, Label, ContentRow, ArrowDownIcon, ArrowUpIcon } from './styles';
import { Point } from '../../Point';

interface IProps {
  data: IParsedDataCard
}

export const VariationSection: React.FC<IProps> = ({ data }) => {
  return (
    <>
      <Section>
        <Label> NA DÉCADA</Label>
        <ContentRow>
          <Point color='green' />
          <p>
            <b>{data?.decada.melhor.UF}</b>
            {` ${data?.decada.melhor.valor}`}
          </p>
        </ContentRow>
        <ContentRow className='disable' >
        <Point color='red' />

          <p>
          <b>{`${data?.decada.pior.UF }`}</b>
            {`${data?.decada.pior.valor}`}
          </p>
        </ContentRow>
      </Section>
      <Section >
        <Label> NO ÚLTIMO ANO </Label>
        <ContentRow>
        <Point color='green' />

          <p>
          <b>{data?.ano.melhor.UF}</b>
            {`${data?.ano.melhor.valor}`}
          </p>
        </ContentRow>
        <ContentRow className='disable dis' >
        <Point color='red' />
          <p>
          <b>{data?.ano.pior.UF}</b>
            {`${data?.ano.pior.valor}`}
          </p>
        </ContentRow>
      </Section>
    </>
  );
};
